import {create} from "zustand";
import {ApiFailure, ApiSuccess} from "../api/types/ApiResponse";
import {LoginResponse} from "../api/types/LoginResponse";

interface AuthState {
    login?: string,
    password?: string,
    response?: ApiSuccess<LoginResponse> | ApiFailure<any>,
}

interface AuthStore extends AuthState {
    setCredentials: (login: string, password: string, response: ApiSuccess<LoginResponse> | ApiFailure<any>) => void
}

export const useAuthStore = create<AuthStore>()((set) => ({
    setCredentials: (login, password, response) => set((s) => ({...s, login, password, response}))
}));